import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, Subscription } from 'rxjs';
import { MyConfigOrganization } from '../../../../../models/myConfig';
import { BackOffice24StatesService } from '../../state/back-office24-states.service';


@Component({
    selector: 'app-arrivaldeparture-list',
    templateUrl: './arrivaldeparture-list.component.html',
    styleUrls: ['./arrivaldeparture-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArrivalDepartureListComponent implements OnInit, OnDestroy {
  @Input() organization: MyConfigOrganization;
  private orgSubscription: Subscription = new Subscription();
  componentDestroyed$: Subject<boolean> = new Subject();
  isLoading: boolean = false;
  activeRequests: number = 0;

  constructor(
    public snackBar: MatSnackBar,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
    private backOffice24StatesService: BackOffice24StatesService,
  ) {}

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.subscribe(
      org => this.organization = org
    );
  }

  ngOnDestroy() {
    this.orgSubscription.unsubscribe();
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  incrementRequests(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) this.isLoading = true;
  }

  decrementRequests(): void {
    if (this.activeRequests > 0) this.activeRequests--;
    if (this.activeRequests === 0) this.isLoading = false;
  }

}
